/* 
Mixin for use with chart components.
*/
import _ from "underscore";

export default {
  methods: {
    isChartEmpty(data) {
      var isEmpty = true;
      if (data && data.datasets && data.datasets[0] && data.datasets[0].data) {
        isEmpty = _.every(data.datasets, d => {
          return _.every(d.data, v => {
            return v === 0;
          });
        });
      }
      return isEmpty;
    }
  }
};
